import { render, staticRenderFns } from "./ClusterLink.vue?vue&type=template&id=045b0e70&scoped=true&"
import script from "./ClusterLink.vue?vue&type=script&lang=js&"
export * from "./ClusterLink.vue?vue&type=script&lang=js&"
import style0 from "./ClusterLink.vue?vue&type=style&index=0&id=045b0e70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045b0e70",
  null
  
)

export default component.exports